import PropTypes from "prop-types"
import React, { useContext } from "react"
import { ContactsContext } from "src/main/Contact/index"

import Button from "src/components/Button"
import Modal from "src/components/Modal"

import { useToast } from "src/hooks/use_toast"
import { useTracker } from "src/hooks/use_tracker"

const MarinaInviteModal = ({ isOpen, setIsOpen }) => {
  const { marinaInvitePath, trackingProperties } = useContext(ContactsContext)
  const showToast = useToast()
  const tracker = useTracker()

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <Modal.Header title="Invite customers to join you on Dockwa" />
      <Modal.Body>
        <div className="mb-8 flex flex-col space-y-4">
          <span className="text-gray-600">
            Use this link to invite customers to connect with your marina.
            Connecting their Dockwa account with your marina will allow them to
            view and manage any existing reservations, contracts, or invoices
            they have with you.
          </span>
          <div className="card flex items-center justify-between border bg-gray-100">
            <a
              className="font-semibold"
              href={marinaInvitePath}
              target="_blank"
              rel="noreferrer"
            >
              {marinaInvitePath}
            </a>
            <Button
              variant="secondary"
              onClick={() => {
                navigator.clipboard.writeText(marinaInvitePath)
                showToast("Link copied to clipboard!", { type: "success" })
                tracker.trackEvent(
                  "marina_invite:copy_link_clicked",
                  trackingProperties
                )
              }}
            >
              Copy Link
            </Button>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer onlyCancel onClose={handleClose} cancelBtnText="Close" />
    </Modal>
  )
}

MarinaInviteModal.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
}

export default MarinaInviteModal
